// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"736":"36d584c5","798":"8388772e","895":"501cd408"}[chunkId] + ".css";
};